/* Shop All UGC1 — shared CakeTrack UGC media fetch helper.
   Pulls curated media from the dedicated UGC Media Worker.
   Used by both the woven grid tiles (sa-ugc1.js) and the gallery section. Idempotent +
   in-memory cached so the same family/surface is only fetched once per page. */
window.SaUgc1Reviews = window.SaUgc1Reviews || (function () {
  var WORKER = 'https://cakemiami-ugc-media.pavlovacake305.workers.dev';
  var FETCH_TIMEOUT_MS = 2500;
  var cache = {};

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function mediaToReview(media) {
    var review = media && media.review ? media.review : {};
    return {
      review_text: review.review_text || '',
      reviewer_display_name: review.reviewer_display_name || '',
      rating: review.rating,
      submitted_at: review.submitted_at || media.review_submitted_at || media.media_created_at || '',
      photo_urls: media.image_url ? [media.image_url] : [],
      canonical_product_url: media.canonical_product_url || '',
      product_handle: handleFromUrl(media.canonical_product_url)
    };
  }

  function fetchMedia(url, key) {
    if (cache[key]) return cache[key];
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT_MS) : null;
    cache[key] = fetch(url, { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : { media: [] }; })
      .then(function (d) {
        var rows = Array.isArray(d) ? d : (d.media || []);
        return rows.filter(function (media) { return media && media.image_url; });
      })
      .finally(function () { if (timer) clearTimeout(timer); })
      .catch(function () { return []; });
    return cache[key];
  }

  function get(family, limit) {
    family = String(family || '').trim();
    var n = limit || 4;
    if (!family) return Promise.resolve([]);
    var key = 'family|' + family + '|' + n;
    var url = WORKER + '/api/ugc/media?family=' + encodeURIComponent(family) +
      '&sort=priority_recent&limit=' + n;
    return fetchMedia(url, key).then(function (media) { return media.map(mediaToReview); });
  }

  function getShopAll(limit) {
    var n = limit || 10;
    var key = 'shop_all|' + n;
    var url = WORKER + '/api/ugc/media?surface=shop_all&sort=random&limit=' + n;
    return fetchMedia(url, key).then(function (media) {
      return media.map(function (row) {
        var rv = mediaToReview(row);
        return {
          rv: rv,
          handle: rv.product_handle || ''
        };
      }).filter(function (item) {
        return item.rv.photo_urls.length;
      });
    });
  }

  // Strip emoji/symbols + wrapping quotes + collapse whitespace.
  function clean(text) {
    return String(text || '')
      .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{2190}-\u{21FF}]/gu, '')
      .replace(/\s+/g, ' ')
      .replace(/^["“”'`]+|["“”'`]+$/g, '')
      .trim();
  }

  // Host/guest/celebration words (StoryBrand: the host is the hero) rank ABOVE generic praise.
  var KW_HOST = /\b(guests?|host|party|hit|proud|loved|friends?|ladies|everyone|crowd|gathering|celebrat|birthday)\b/i;
  var KW_PRAISE = /\b(perfect|beautiful|gorgeous|stunning|delicious|best|amazing|incredible|favou?rite|obsessed|wow|professional|impeccable|recommend|happy)\b/i;

  // Score the best short line a single review can yield. 4 host-centric, 3 praise,
  // 2 clean short sentence, 1 hard-trimmed fragment.
  function quoteOf(text, max) {
    var t = clean(text);
    max = max || 60;
    var byLen = function (a, b) { return a.length - b.length; };
    // Candidate lines: whole sentences, plus comma/semicolon clauses of any long sentence
    // (so a punchy phrase buried mid-sentence, e.g. "both were SO AMAZING", can surface).
    var sentences = (t.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [t]);
    var segs = [];
    sentences.forEach(function (s) {
      s = s.trim().replace(/^["“”'`]+|["“”'`]+$/g, '');
      segs.push(s);
      if (s.length > max) s.split(/\s*[,;]\s*/).forEach(function (c) { segs.push(c.trim()); });
    });
    segs = segs.filter(function (v, i) { return v && segs.indexOf(v) === i; });
    var fit = segs.filter(function (s) { return s.length >= 14 && s.length <= max; }).sort(byLen);
    var host = fit.filter(function (s) { return KW_HOST.test(s); }).sort(byLen);
    if (host.length) return { q: host[0], score: 4 };
    var praise = fit.filter(function (s) { return KW_PRAISE.test(s); }).sort(byLen);
    if (praise.length) return { q: praise[0], score: 3 };
    if (fit.length) return { q: fit[0], score: 2 };
    if (t.length <= max) return { q: t, score: 2 };
    var cut = t.slice(0, max), sp = cut.lastIndexOf(' ');
    return { q: (sp > 30 ? cut.slice(0, sp) : cut).replace(/[\s,;:.!?\-–]+$/, '') + '…', score: 1 };
  }

  // From a set of reviews, pick the one whose text yields the best short quote.
  function pickBest(reviews, max) {
    var best = null;
    (reviews || []).forEach(function (rv) {
      var Q = quoteOf(rv.review_text, max);
      // higher score wins; on a tie, the shorter (punchier) quote wins
      if (!best || Q.score > best.Q.score || (Q.score === best.Q.score && Q.q.length < best.Q.q.length)) {
        best = { rv: rv, Q: Q };
      }
    });
    return best;
  }

  function pullQuote(text, max) { return quoteOf(text, max).q; }
  function scoreQuote(text, max) { return quoteOf(text, max).score; }

  // Only return a quote when it's a genuinely clean, short, positive line; otherwise ''
  // (the tile/card then goes photo-forward instead of showing an awkward fragment).
  function cleanQuote(text, max) {
    max = max || 46;
    var Q = quoteOf(text, max);
    return (Q.score >= 3 && Q.q.length <= max && Q.q.indexOf('…') === -1) ? Q.q : '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // "Shop the ___" label: always the specific cake, shortened (drops the generic
  // "Pavlova Cake" prefix but keeps Mini/Cups/Cakes/Frozen so each stays distinct).
  function shopLabel(title) {
    var s = String(title || '')
      .replace(/\s*[-·]\s*Serves.*$/i, '')
      .replace(/^Pavlova Cake\s*[-·]\s*/i, '')        // Pavlova Cake - 10-inch Round -> 10-inch Round
      .replace(/^Frozen Pavlova\s*[-·]\s*/i, 'Frozen ') // Frozen Pavlova - 10-inch Round -> Frozen 10-inch Round
      .replace(/\bPavlova\b\s*/i, '')                  // Mini Pavlova Cakes - 20-Pack -> Mini Cakes - 20-Pack
      .replace(/\s+[-·]\s+/g, ' ')                     // only the " - " separator, not 10-inch / 20-Pack
      .replace(/\s+/g, ' ')
      .trim();
    return s ? 'the ' + s : 'this cake';
  }

  return { get: get, getShopAll: getShopAll, pullQuote: pullQuote, scoreQuote: scoreQuote, cleanQuote: cleanQuote, pickBest: pickBest, esc: esc, shopLabel: shopLabel };
})();
